// src/api/userGroupApi.js
import axiosClient from "./axiosClient";

const userGroupApi = {
  getRole: (UgId) => {
    return axiosClient.get(`/role_groups/${UgId}`, {
      withCredentials: true,
    });
  },
  upsertRoleGroup: (UgId, data) => {
    let postData = {
      UgId: UgId,
      Roles: data,
    };
    return axiosClient.post("/role_groups/upsert", postData, {
      withCredentials: true,
    });
  },
};

export default userGroupApi;
